import React from "react";
import styles from "../../styles/HomePage.module.css";
import SongProgressionDemo from "../../pages/demos/SongProgressionDemo";

export default function DemoSection() {
    return (
        <section className={styles.demo}>
            <h2 className={styles.sectionTitle}>See the Training in Action</h2>
            <p className={styles.demoSubtitle}>
                Play these famous songs. They're the exact same ear training skills you'll practice—
                just in real music instead of isolated exercises.
            </p>

            <div className={styles.demoContainer}>
                <div className={styles.demoPlayer}>
                    <SongProgressionDemo />
                </div>

                <div className={styles.demoInsights}>
                    <div className={styles.insightIntro}>
                        <strong>What you're hearing:</strong> Both songs use the same types of chords (major and minor).
                        The difference? Key, progression pattern, and rhythm.
                    </div>

                    <div className={styles.insight}>
                        <div className={styles.insightIcon}>🎵</div>
                        <div className={styles.insightContent}>
                            <h4 className={styles.insightTitle}>Interval Training → Recognize each note jump</h4>
                            <p className={styles.insightText}>
                                When you hear C to E or A to C#, you're hearing the intervals you'll train.
                                Master intervals = figure out any melody.
                            </p>
                        </div>
                    </div>

                    <div className={styles.insight}>
                        <div className={styles.insightIcon}>🎹</div>
                        <div className={styles.insightContent}>
                            <h4 className={styles.insightTitle}>Chord Training → Know major from minor</h4>
                            <p className={styles.insightText}>
                                C major (happy) vs Am (sad). A major vs C#m. Train your ear to identify chord quality
                                instantly = play along to any song.
                            </p>
                        </div>
                    </div>

                    <div className={styles.insight}>
                        <div className={styles.insightIcon}>🎸</div>
                        <div className={styles.insightContent}>
                            <h4 className={styles.insightTitle}>Progression Training → Hear the movement</h4>
                            <p className={styles.insightText}>
                                "Let It Be" goes I→V→vi→IV in C. "Someone Like You" goes I→iii→vi→IV in A.
                                Different keys, similar pattern = thousands of songs use these.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
